import "react";
import { useTranslation } from "react-i18next";
import { Icon, Label } from "semantic-ui-react";

import { PreferredCommunicationChannel } from "components";
import {
  DESK_COMMUNICATION_STATUSES,
  KEYLOCKER_COMMUNICATION_EVENT_TYPE,
  KEYLOCKER_COMMUNICATION_STATUSES,
  KIOSK_COMMUNICATION_EVENT_TYPES,
  KIOSK_COMMUNICATION_STATUSES
} from "models";
import "modules/AppointmentDetails/components/CustomerActions/components/CheckInCustomerCorrectInfo/CheckInCustomerCorrectInfo.scss";

import type { Appointment, COMMUNICATION_CHANNELS } from "models";

export const getEmail = (appointment: Appointment) => appointment.customer_communication?.correct_email || appointment.customcom_correct_email;
export const getPhone = (appointment: Appointment) => appointment.customer_communication?.correct_phone || appointment.customcom_correct_phone;

export const getPreferredChannel = (appointment: Appointment) => {
  const { desk_communications } = appointment;

  if (!desk_communications?.some(dc => dc.status >= DESK_COMMUNICATION_STATUSES.DeskCheckInAnswered)) return;

  return (
    appointment.customer_driver?.preferred_communication_channel ??
    appointment.customer_owner?.preferred_communication_channel ??
    appointment.customer_contract?.preferred_communication_channel
  );
};

export const getKeylockerPhoneNumber = (appointment: Appointment) => {
  const { keylocker_communications } = appointment;

  if (!keylocker_communications?.length) return;

  const keylockerComm = keylocker_communications.find(comm => comm.status >= KEYLOCKER_COMMUNICATION_STATUSES.CheckInAnswered);
  const keylockerAnsweredEvent = keylockerComm?.events?.find(evt => evt.type === KEYLOCKER_COMMUNICATION_EVENT_TYPE.CheckInAnswered && evt.correct_phone);

  return keylockerAnsweredEvent?.correct_phone;
};

export const getKioskPhoneNumber = (appointment: Appointment) => {
  const { kiosk_communications } = appointment;

  if (!kiosk_communications?.length) return;

  const kioskComm = kiosk_communications.find(comm => comm.status >= KIOSK_COMMUNICATION_STATUSES.CheckInAnswered);
  const kioskAnsweredEvent = kioskComm?.events?.find(evt => evt.type === KIOSK_COMMUNICATION_EVENT_TYPES.CheckInAnswered && evt.correct_phone);

  return kioskAnsweredEvent?.correct_phone;
};

type CheckInCustomerCorrectInfoProps = {
  correctInfo: string[];
  preferredChannel?: COMMUNICATION_CHANNELS;
};

export const CheckInCustomerCorrectInfo = ({ correctInfo, preferredChannel }: CheckInCustomerCorrectInfoProps) => {
  const { t } = useTranslation();

  if (!correctInfo.length && !preferredChannel) return null;

  return (
    <div className="CheckInCustomerCorrectInfo">
      <Label className="address-card-label">
        <Icon className="address card" />
      </Label>

      {correctInfo.map((info, index) => (
        <Label key={index} basic>
          {info}
        </Label>
      ))}

      {!!preferredChannel && (
        <Label basic>
          {t("v8_preferred_communication_channel", "Preferred Communication Channel")}: <PreferredCommunicationChannel channel={preferredChannel} />
        </Label>
      )}

      <span>{t("v8_contact_info_provided_by_customer", "Contact info provided by customer")}</span>
    </div>
  );
};
